import React from 'react';

import { Box, Separator } from '@betterment/samba-react';

import { Row } from './Row';

import { ActivityItemNode } from '../types';

interface ActivityTableProps {
  activityItems: ActivityItemNode[];
}

export const Table: React.FC<ActivityTableProps> = ({ activityItems }) => {
  return (
    <>
      {activityItems.map((item, index) => {
        return (
          <Box
            css={{
              transition: 'background-color 0.2s ease-in-out',
              '&:hover': {
                backgroundColor: 'background.transparent.hover',
                cursor: 'pointer',
              },
            }}
            key={`activity-row-${index}`} // eslint-disable-line react/no-array-index-key
          >
            <Separator css={{ fullWidthWithInset: 'space.400' }} />
            <Row item={item} />
          </Box>
        );
      })}
    </>
  );
};
